"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Uploader = require("../../../../../Uploader"),
    _AssetPreview = _interopRequireDefault(require("../../../../../AssetPreview"));

function CommentAssetPreview(a) {
  var b = a.asset;
  return _react["default"].createElement(_AssetPreview["default"], {
    asset: b,
    height: 90,
    width: 90
  });
}

var _default = (0, _Uploader.withAssetSelector)(CommentAssetPreview);

exports["default"] = _default;